export const API_BASE_URL =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ??
  "http://localhost:8787";

export const DEFAULT_ORG_SLUG =
  (import.meta.env.VITE_ORG_SLUG as string | undefined) ?? "";

// Surfaced only for super_admin accounts, as a non-production warning pill
// in the topbar. See TopBar.tsx. Defaults to "production" in any built artefact
// that isn't explicitly labelled otherwise.
export const ENVIRONMENT: "production" | "staging" | "development" =
  ((import.meta.env.VITE_ENVIRONMENT as string | undefined) as
    | "production"
    | "staging"
    | "development"
    | undefined) ?? (import.meta.env.DEV ? "development" : "production");

// Cloudflare Turnstile site key (public). When absent the widget is not
// rendered and auth forms submit without a token — server-side
// verification also fails open in that case, so dev + staging don't need
// a key. For production set this at Pages build time.
export const TURNSTILE_SITE_KEY =
  (import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined) ?? "";
